/* eslint no-unused-vars: ["error", { "varsIgnorePattern": "AOTravellerEnquiryStore" }] */

import {
  lsIsAvailable, sendRequest, logged, sendGoogleEvent,
} from '@html/_common/utils';

export default class AOTravellerEnquiryStoreES6 {
  constructor() {
    this.STORAGE_KEY = 'bcplatest.info';
    this.TEMPLATES_ENDPOINT = '/api/enquiry/traveller-store';

    this.GA_CATEGORY = 'Local BCP Access';
    this.GA_ACTION = 'open last enquiry';

    this.VALIDITY_DURATION = 6.048e+8; // should expire in a week

    this.path = '';
    this.createdAt = 0;
    this.seen = false;
    this.lastSeenAt = 0;

    this.BCP_PLACEHOLDER_ID = 'bcp-react';
    this.OPEN_QUESTION_STATUS = 0;

    this.selectors = {
      main: '.js-ao-header-traveller-enquiry-store',
      desktop: {
        menu: '.js-ao-header-desktop-nav',
        icon: '.ao-header-navigation__profile-placeholder',
      },
      mobile: {
        menu: '.js-ao-header-handheld-nav',
        icon: '.js-ao-header-t-menu',
      },
    };
  }

  set data(dataObject) {
    this.path = dataObject.path || this.path;
    this.createdAt = dataObject.createdAt || this.createdAt;
    this.seen = !!dataObject.seen;

    if (this.seen) {
      this.lastSeenAt = dataObject.lastSeenAt || Date.now();
    }

    this.setStore();
  }

  get isExpired() {
    return Date.now() >= this.createdAt + this.VALIDITY_DURATION;
  }

  get enquiryId() {
    const pathArray = this.path.split('/');
    return parseInt(
      (pathArray[pathArray.length - 1]
        .split('?enquiryCode=')[0] || ''),
      10,
    );
  }

  get rawData() {
    return lsIsAvailable() && localStorage.getItem(this.STORAGE_KEY);
  }

  initialize() {
    if (logged) {
      return;
    }

    if (!this.rawData) {
      return;
    }

    try {
      this.data = JSON.parse(this.rawData);
    } catch (e) {
      this.clearStore();
      return;
    }

    if (this.isExpired) {
      this.clearStore();
      return;
    }

    this.initUI();
  }

  setStore() {
    if (!lsIsAvailable()) {
      return;
    }
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify({
      path: this.path,
      createdAt: this.createdAt,
      seen: this.seen,
      lastSeenAt: this.lastSeenAt,
    }));
  }

  clearStore() {
    if (!lsIsAvailable()) {
      return;
    }
    localStorage.removeItem(this.STORAGE_KEY);
  }

  initUI() {
    if (!this.path || this.isEnquiryScreen()) {
      return;
    }

    if ($(this.selectors.main).length) {
      this.initGA();
      return;
    }

    if (
      !$(this.selectors.desktop.menu).length
            || !$(this.selectors.mobile.menu).length) {
      return;
    }

    sendRequest(this.TEMPLATES_ENDPOINT, {
      bcpLink: this.path,
      lastSeenAt: +this.seen && this.lastSeenAt,
    }, ({ components, hasNewMessage }) => {
      if (!components) {
        return;
      }
      const { cta, indicator } = components;

      if (hasNewMessage) {
        this.data = { seen: false };
      }

      $(`${this.selectors.desktop.menu} nav ul.js-ao-header-navigation__dropdown-list--profile`).append(cta);

      $(`${this.selectors.mobile.menu} ul li.pr-end`).removeClass('pr-end').after(cta);

      if (!this.seen) {
        $(`${this.selectors.desktop.icon}`).after(indicator);
        $(`${this.selectors.mobile.icon}`).append(indicator);
      }

      this.initGA();
    });
  }

  initGA() {
    sendGoogleEvent(
      this.GA_CATEGORY,
      'BCP access available',
      this.seen ? 'Without red indicator' : 'With red indicator',
      { nonInteraction: true },
    );

    $(`${this.selectors.main}`).on('click', 'a', () => {
      this.data = {
        seen: true,
      };
      $(`${this.selectors.main}__indicator`).addClass('hid');
      sendGoogleEvent(
        this.GA_CATEGORY,
        this.GA_ACTION,
        this.enquiryId,
      );
    });
  }

  isEnquiryScreen() {
    const $bcpPlaceholder = $(`#${this.BCP_PLACEHOLDER_ID}`);

    if (!$bcpPlaceholder.length || !$bcpPlaceholder.data('code')) {
      return false;
    }

    if (parseInt(
      $bcpPlaceholder.data('code')
        .split('-')[0] || '',
      10,
    ) !== this.enquiryId) {
      return false;
    }

    if (parseInt($bcpPlaceholder.data('status'), 10) !== this.OPEN_QUESTION_STATUS) {
      this.clearStore();
      return true;
    }

    return true;
  }

  handleEnquiryCreated(path) {
    if (!path || logged) {
      return;
    }
    this.data = { path, createdAt: Date.now() };
  }
}
